import { render, staticRenderFns } from "./modalDetalleProducto.vue?vue&type=template&id=ae7ca704&"
import script from "./modalDetalleProducto.vue?vue&type=script&lang=js&"
export * from "./modalDetalleProducto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports